import classnames from 'classnames';
import { Utils } from 'common';
import React from 'react';

const { Util } = Utils;

export const DataDisplayPanel = ({
	label,
	body = '',
	dataqa,
	amount = '',
	serviceDataDisplay = false,
	serviceHeaderData = false,
	trackingDataDisplay = false,
	bodyClassName = '',
	containerClassName = '',
}) =>
	body ? (
		<>
			{serviceDataDisplay ? (
				<div
					className={classnames(
						'display-detail',
						serviceHeaderData ? '' : 'p-col-12 ',
						containerClassName
					)}
				>
					<div
						className={classnames(
							serviceHeaderData
								? 'display-service-header-label'
								: 'display-label p-col-4'
						)}
					>
						{label}
					</div>
					<div
						className={classnames(
							amount ? 'service-dot-spacer' : '',
							!serviceHeaderData && body.length > 25
								? 'display-white-space'
								: '',
							serviceHeaderData
								? 'display-service-header-body'
								: 'display-body p-col-7'
						)}
						data-qa={`${dataqa}-body`}
						{...{ dataqa: `${dataqa}-body` }}
					>
						{body}
					</div>
					{amount && (
						<div
							className="p-col-1 display-amount"
							data-qa={`${dataqa}-body`}
							{...{ dataqa: `${dataqa}-body` }}
						>
							{Util.formatCurrency(amount)}
						</div>
					)}
				</div>
			) : (
				<div className="p-col-12 display-detail">
					<div
						className={classnames(
							'display-label',
							trackingDataDisplay ? 'p-col-4' : 'p-col-5'
						)}
					>
						{label}
					</div>

					<div
						className={classnames(
							'display-body',
							trackingDataDisplay ? 'p-col-7' : 'p-col-6',
							bodyClassName
						)}
						data-qa={`${dataqa}-body`}
						{...{ dataqa: `${dataqa}-body` }}
					>
						{body}
					</div>
				</div>
			)}
		</>
	) : null;
